import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgJhipsterModule} from 'ng-jhipster';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {CookieModule} from 'ngx-cookie';
import {FileUploadModule} from 'ng2-file-upload';
import {Angulartics2Module} from 'angulartics2';

@NgModule({
    imports: [
        NgbModule.forRoot(),
        NgJhipsterModule.forRoot({
            alertAsToast: false,
            i18nEnabled: true,
            defaultI18nLang: 'fr'
        }),
        InfiniteScrollModule,
        FileUploadModule,
        Angulartics2Module.forRoot(),
        CookieModule.forRoot()
    ],
    exports: [
        FormsModule,
        HttpClientModule,
        CommonModule,
        NgbModule,
        NgJhipsterModule,
        InfiniteScrollModule,
        FileUploadModule
    ]
})
export class TelerecourspnrSharedLibsModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared-libs.module.ts